import React from 'react';
import Translate from '../Translate/Translate';
import LocalizedLink from '../LocalizedLink';
import { scrollToTop } from '../../services/Util';

const Social = () => {
  const scrollBackToTop = () => {
    scrollToTop();
  };

  return (
    <div className="flex flex-wrap mt-11 mb-8 -mx-3 justify-between">
      <LocalizedLink
        onClick={scrollBackToTop}
        to="/blogi"
        className="font-axi-bold flex w-full justify-center items-center bg-rgrey-lightborder text-lg min-h-20 transition-all duration-100 cursor-pointer mx-3 my-2.5 rounded-xl hover:bg-black hover:transition-all hover:duration-100 hover:text-white lg:w-[30.33%] lg:min-h-44 lg:text-3xl"
      >
        <Translate component="footer" keyword="blogi-rademar" />
      </LocalizedLink>
      <a
        href="https://www.facebook.com/rademar.ee"
        target="_blank"
        rel="noreferrer"
        className="font-axi-bold flex w-full justify-center items-center bg-rgrey-lightborder text-lg min-h-20 transition-all duration-100 cursor-pointer mx-3 my-2.5 rounded-xl hover:bg-black hover:transition-all hover:duration-100 hover:text-white lg:w-[30.33%] lg:min-h-44 lg:text-3xl"
      >
        Facebook
      </a>
      <a
        href="https://www.instagram.com/rademar.ee/"
        target="_blank"
        rel="noreferrer"
        className="font-axi-bold flex w-full justify-center items-center bg-rgrey-lightborder text-lg min-h-20 transition-all duration-100 cursor-pointer mx-3 my-2.5 rounded-xl hover:bg-black hover:transition-all hover:duration-100 hover:text-white lg:w-[30.33%] lg:min-h-44 lg:text-3xl"
      >
        Instagram
      </a>
    </div>
  );
};

export default Social;
